<template>
  <div class="bybox">
    <div class="title">
      <div @click="returnpage" class="returnbtn" v-if="isApp"><i class="el-icon-arrow-left"></i></div>
      <div class="detaitit">
        购买
      </div>
    </div>
    <div class="subox">
      <img src="../../assets/imgs/logo.png">
      <div class="bytip">购买成功</div>
      <div class="texbox">
        <div class="flexbox fle-sb">
          <div>产品名称</div>
          <div>USDT-180</div>
        </div>
        <div class="flexbox fle-sb">
          <div>产品名称</div>
          <div>USDT-180</div>
        </div>
      </div>
      <div class="btnn bybtn" type="primary" @click="returnpage">完成</div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'makeMoney',
  data () {
    return {

    }
  },
  computed:{
    isApp(){
      return document.documentElement.clientWidth<800?true:false
    },
    routeName(){
      console.log(this.$route.path)
      return this.$route.path
    }
  },
  methods: {
    jumptolcdetail(){
      this.$router.push({path:'/home/detail'})
    },
    returnpage(){
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="scss" scoped>
.bybox{
  .title{
    line-height: 40px;
    color: #fff;
    border-bottom: 1px solid #383838;
    position: relative;
    .returnbtn{
      padding: 0px 10px;
      cursor: pointer;
      position: absolute;
      left: 0px;
      top: 0px;
    }
    .detaitit{
      text-align: center;
      color: #fff;
    }
  }
  .subox{
    color: #fff;
    .texbox{
      padding: 0px 20px;
      box-sizing: border-box;
      line-height: 40px;
    }
    img{
      margin-top: 100px;
      width: 100px;
      height: 100px;
      border-radius: 100%;
    }
    .bytip{
      font-weight: bold;
      line-height: 50px;
    }
    .bybtn{
      width: 80%;
      line-height: 40px;
      margin: 0px auto;
      border-radius: 6px;
      margin-top: 40px;
      background: rgb(37, 23, 240);
    }
  }
}
</style>
